import axios from 'axios';
import authHeader from './auth-header';
import Config from '../config/index';

class ComplainService {
    getPendingComplains() {
        // return axios.get(Config.apiBasePath + '/complains/get-pending-complains?user_id='+id,{ headers: authHeader() });
        return axios.get(Config.apiBasePath + '/complains/get-pending-complains-new',{ headers: authHeader() });
    }
    getResolvedComplains() {
        // return axios.get(Config.apiBasePath + '/complains/get-resolved-complains?user_id='+id,{ headers: authHeader() });
        return axios.get(Config.apiBasePath + '/complains/get-resolved-complains-new',{ headers: authHeader() });
    }
    getPreviousComplains() {
        // return axios.get(Config.apiBasePath + '/complains/get-previous-complains?user_id='+id,{ headers: authHeader() });
        return axios.get(Config.apiBasePath + '/complains/get-previous-complains-new',{ headers: authHeader() });
    }
    workflowApprove(ticketData) {
        return axios.post(Config.apiBasePath + '/call-complain/workflow-approve',ticketData,{ headers: authHeader() });
    }
    submitComplaint(ticket_no, data) {
        return axios.post(Config.apiBasePath + '/complaints', {...data, ticket_no},{ headers: authHeader() });
    }

    getComplaints(params = {}) {
        return axios.get(Config.apiBasePath + '/complaints',{ headers: authHeader(), params });
    }
    downloadAttachment(id) {
        return axios.get(Config.apiBasePath + '/complaints/attachments/' + id,{ headers: authHeader() });
    }

    getResolutionAttachment(id) {
        return axios.get(Config.apiBasePath + '/complaints/resolved-attachments/' + id,{ headers: authHeader() });
    }

    escalateComplaint(id, priority, comment = null) {
        return axios.post(Config.apiBasePath + '/complaints/escalate/' + id, {comment, priority},{ headers: authHeader() });
    }

    resolveComplaint(id, data) {
        return axios.post(Config.apiBasePath + '/complaints/resolve/' + id, data,{ headers: authHeader() });
    }
}

export default new ComplainService();